import {CustomRepeatType} from "@/pages/maintenance/maintenance-create/tabs/general/MaintenanceScheduleGeneralTab.types.ts";

export const CustomRepeatTypeDisplay: Record<CustomRepeatType, string> = {
  [CustomRepeatType.DAY]: "Day",
  [CustomRepeatType.WEEK]: "Week",
  [CustomRepeatType.MONTH]: "Month",
};
